import { isArray } from 'util';

import { Check } from '../check';
import { GroupedCheck } from '../grouped-check';
import { RealTimeCheck } from '../real-time-check';

export class CheckBuilder {

  static checkFromJson(json): Check {
    return (json)
      ? new Check(
        json.hash,
        json.startTime,
        json.endTime,
        json.observations,
        json.user,
        json.startLatitude,
        json.startLongitude,
        json.endLatitude,
        json.endLongitude
      )
      : null;
  }

  static checksFromJsonList(list): Check[] {
    return (isArray(list)) ? list.map(CheckBuilder.checkFromJson) : [];
  }

  static groupedCheckFromJson(json): GroupedCheck {
    return (json)
      ? new GroupedCheck(
        json.hash,
        json.date,
        json.time,
        json.firstname,
        json.lastname
      )
      : null;
  }

  static groupedChecksFromJsonList(list): GroupedCheck[] {
    return (isArray(list)) ? list.map(CheckBuilder.groupedCheckFromJson) : [];
  }

  static realTimeCheckFromJson(json): RealTimeCheck {
    return (json)
      ? new RealTimeCheck(
        json.hash,
        json.firstname,
        json.lastname,
        json.startAddress,
        json.startLatitude,
        json.startLongitude,
        json.startTime
      )
      : null;
  }

  static realTimeChecksFromJsonList(list): RealTimeCheck[] {
    return (isArray(list)) ? list.map(CheckBuilder.realTimeCheckFromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/check.builder.ts